import { createContext } from 'react';

const ExtensionApiContext = /*#__PURE__*/createContext(null);

export { ExtensionApiContext };
